const DNS_LABEL_SOURCE = "[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?";
// Duplicated from DNS_LABEL_PATTERN in hostClassification.ts, which imports this module — sharing would be circular.
const VANITY_HOST_PATTERN = new RegExp(`^(${DNS_LABEL_SOURCE})\\.portal\\.silverfern\\.(com|red)$`);

export const RESERVED_PORTAL_LABELS: ReadonlySet<string> = new Set([
	"admin",
	"api",
	"app",
	"assets",
	"auth",
	"cdn",
	"help",
	"login",
	"mail",
	"portal",
	"static",
	"status",
	"support",
	"www"
]);

export type VanityHostResolution =
	| { kind: "none" }
	| { kind: "reserved"; label: string }
	| { kind: "tenant"; tenantSlug: string };

const resolveVanityHost = (host: string): VanityHostResolution => {
	const normalized = host.toLowerCase().replace(/:\d+$/, "").replace(/\.$/, "");
	const match = VANITY_HOST_PATTERN.exec(normalized);
	if (!match) return { kind: "none" };

	const label = match[1];
	if (RESERVED_PORTAL_LABELS.has(label)) return { kind: "reserved", label };
	return { kind: "tenant", tenantSlug: label };
};

export const isVanityPortalHost = (host: string): boolean => resolveVanityHost(host).kind !== "none";

export default resolveVanityHost;
